import React from 'react';
import type { PatientDetailsPatientProp } from './internal';
import {
  PatientDetailsHorizontalFlexElement,
  PatientDetailsSection
} from './internal';
import { intl } from '../../lib';

/**
 * Props for a {@link PatientDetailsContactInformation} component.
 */
export type PatientDetailsContactInformationProps = PatientDetailsPatientProp;

/**
 * Component for displaying a patient's contact information details.
 *
 * @param patient the patient whose data is displayed
 * @param props leftover {@link PatientDetailsContactInformationProps}
 * @return the created {@link React.JSX.Element}.
 * @constructor
 */
export function PatientDetailsContactInformation({
  patient,
  ...props
}: Readonly<PatientDetailsContactInformationProps>): React.JSX.Element {
  const mobilePhone = patient.telecomAddresses?.find(addr => addr.type === 'CP')
    ?.value;
  const homePhone = patient.telecomAddresses?.find(addr => addr.type === 'PH')
    ?.value;

  if (!mobilePhone && !homePhone && !patient.email) {
    return <></>;
  }

  return (
    <PatientDetailsSection
      {...props}
      className="ehs-patient-details-contact-information"
      title={intl('patientsearchportlet.view.createPatient.contact')}
    >
      {mobilePhone && (
        <PatientDetailsHorizontalFlexElement
          label={intl('view.patient.mobile')}
          value={mobilePhone}
        />
      )}
      {homePhone && (
        <PatientDetailsHorizontalFlexElement
          label={intl('view.patient.homephone')}
          value={homePhone}
        />
      )}
      {patient.email && (
        <PatientDetailsHorizontalFlexElement
          label={intl('view.patient.email')}
          value={patient.email}
        />
      )}
    </PatientDetailsSection>
  );
}
